import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponsePaged } from '@core/interfaces/api.interface';
import { BaseService } from '@core/services/base.service';
import { mapPagedResponse } from '@core/utils/mapper-response-paged.util';
import {
  MaintenanceRoutine,
  MaintenanceRoutineFilter,
  MaintenanceRoutineForm,
} from '@features/advanced-maintenance/interfaces/maintenance.interface';

@Injectable({ providedIn: 'root' })
export class MaintenanceRoutinesService extends BaseService {
  constructor() {
    super('MaintenanceRoutines');
  }

  getAll(params: MaintenanceRoutineFilter): Observable<ApiResponsePaged<MaintenanceRoutine>> {
    return this.GET('', params, { observe: 'response' }).pipe(
      mapPagedResponse<MaintenanceRoutine>(),
    );
  }

  getById(id: string): Observable<MaintenanceRoutine> {
    return this.GET<MaintenanceRoutine>(id);
  }

  create(payload: Omit<MaintenanceRoutineForm, 'id'>): Observable<MaintenanceRoutine> {
    return this.POST<MaintenanceRoutine>('', payload);
  }

  update(id: string, payload: MaintenanceRoutineForm): Observable<MaintenanceRoutine> {
    return this.PUT<MaintenanceRoutine>(id, payload);
  }

  export(params: MaintenanceRoutineFilter): Observable<Blob> {
    return this.GET<Blob>('get-excel', params, {
      responseType: 'blob',
    });
  }

  delete(id: string): Observable<void> {
    return this.DELETE<void>(id);
  }
}
